import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XcLoadingComponent } from './loading.component';

@NgModule({
  declarations: [
    XcLoadingComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    XcLoadingComponent,
  ]
})
export class XcLoadingModule { }
